'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002econvert$002e$002dAs$002dScala$002dConverters from "./scala.collection.convert.-As-Scala-Converters.js";
import * as $j_scala$002ejdk$002ejavaapi$002e$002dCollection$002dConverters$0024 from "./scala.jdk.javaapi.-Collection-Converters$.js";
var $p;
/** @constructor */
function $c_sc_convert_AsScalaExtensions$SetHasAsScala(outer, s) {
  this.MW = null;
  this.MW = s;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_sc_convert_AsScalaExtensions$SetHasAsScala as $c_sc_convert_AsScalaExtensions$SetHasAsScala };
$p = $c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sc_convert_AsScalaExtensions$SetHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$SetHasAsScala() {
}
export { $h_sc_convert_AsScalaExtensions$SetHasAsScala as $h_sc_convert_AsScalaExtensions$SetHasAsScala };
$h_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = $p;
$p.Sv = (function() {
  return $j_scala$002ecollection$002econvert$002e$002dAs$002dScala$002dConverters.$f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set($j_scala$002ejdk$002ejavaapi$002e$002dCollection$002dConverters$0024.$m_s_jdk_javaapi_CollectionConverters$(), this.MW);
});
var $d_sc_convert_AsScalaExtensions$SetHasAsScala = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_convert_AsScalaExtensions$SetHasAsScala, "scala.collection.convert.AsScalaExtensions$SetHasAsScala", ({
  sP: 1
}));
export { $d_sc_convert_AsScalaExtensions$SetHasAsScala as $d_sc_convert_AsScalaExtensions$SetHasAsScala };
